export const enum TErrCodes {
  SHOW_ALERT,
  NONE,
}

export type Question = {
  status: string;
  subjectType: string;
  title: string;
  secret: boolean;
  questionType: string;
  enabled?: boolean;
  qnaType: string;
  bNo: string;
  registrationDate: string;
  courseName?: string;
  videoTimestamp?: string;
  videoLink?: string;
  textbookName?: string;
  textbookPage?: string;
  problemNo?: number | null;
  questionContent?: string;
  courseAttendance?: string;
  student?: Student;
  files: File[];
  answers?: Answer[];
  nextbNo?: string;
  prevbNo?: string;
  advice: Advice[];
  transfer?: Transfer;
  bonus: number;
};

export type Student = {
  id: number;
  studentName: string;
  studentId: string;
  grade: string;
  department: string;
  subjectLevel: string;
  memo: string;
};

export type Answer = {
  id: number;
  status: string;
  title: string;
  classificationType: string;
  classificationDifficulty: string;
  content: string;
  registrationDate: string;
  responderId: string;
  responderName: string;
  files: File[];
  user?: User;
  createdAt: string;
  isScrapped: boolean;
  monitoringStatus: number;
  lastStatusUpdate?: string;
  monitor?: User;
  reward: number;
  bonus: number;
  enabled: boolean;
};

export type File = {
  id: number;
  filename: string;
  fileno: string;
  filepath: string;
  upldfilename: string;
};

export interface Notice {
  id: number;
  type: string;
  title: string;
  content: string;
  author: string;
  createdAt: string;
  isViewed: boolean;
  isFixed: boolean;
}

export interface Grade {
  id: number;
  name: string;
  amount: number;
  userCount: number;
}

export interface User {
  id: number;
  name: string;
  userId: string;
  phone: string;
  residentId1: string;
  residentId2: string;
  daesungId: string;
  bank: string;
  bankNumber: string;
  lastSeen: string;
  grade: Grade;
  isLinked: boolean;
  createdAt: string;
  answerCount?: number;
  dayCount?: number;
  weekCount?: number;
  monthCount?: number;
  reportCount?: number;
  transferCount?: number;
  startMonth?: Date;
  startWeek?: Date;
  startDay?: Date;
  reward?: number;
  deactivationCount?: number;
}

export interface Advice {
  id: number;
  content: string;
  user?: User;
  createdAt: string;
}

export interface Transfer {
  id: number;
  content: string;
  user?: User;
  createdAt: string;
  files?: File[];
}

export interface Report {
  id: number;
  content: string;
  status: number;
  createdAt: string;
  user?: User;
  answer: {
    questionBNo: string;
  };
}

export interface Deactivation {
  id: number;
  reactivationDate?: string;
  createdAt: string;
}

export interface SmartEditorType {
  getContent: () => string;
  focus: () => void;
  setContent: (content: string) => void;
}
